import { toast } from "react-toastify";
import { getApiBaseUrl } from "../../utils/apiBaseUrl";

/**
 * @param payload - The address data to be sent.
 * @param token - The authentication token.
 * @returns A promise that resolves to the API response.
 */
export async function addNewAddressAsync(payload: any, token: string,  t: (key: string) => string): Promise<any> {


  if (!navigator.onLine) {
    toast.error(t("internetConnection"), { toastId: "offline-error" });
    return null;
  }

    try {
      const baseUrl = getApiBaseUrl();
      const response = await fetch(
        `${baseUrl}/api/address/AddNewAddressAsync`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          `Error: ${response.status} ${response.statusText} - ${JSON.stringify(errorData)}`
        );
      }
  
      const result = await response.json();
      return result;
    } catch (error) {
      // console.error('Error adding new address:', error);
      throw error;
    }
  }
  